export const mounted = el => el.focus();
